import { render } from "./fullDialog.vue?vue&type=template&id=bea6c79a&scoped=true"
import script from "./fullDialog.vue?vue&type=script&lang=js"
export * from "./fullDialog.vue?vue&type=script&lang=js"

import "./fullDialog.vue?vue&type=style&index=0&id=bea6c79a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea6c79a"]])

export default __exports__